// extracted by mini-css-extract-plugin
export default {"status":"status_status__S+-88","color":"status_color__8Gc52","green":"status_green__GPkN4","red":"status_red__Y4UeL"};